import React, { useEffect, useRef, useState, useCallback } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import { Dropdown } from 'primereact/dropdown';
import { useFormik } from 'formik';
import { Dialog } from 'primereact/dialog';
import { Api } from "../../../../services/api";
import { Toast } from 'primereact/toast'
import { InputNumber } from 'primereact/inputnumber';
import { Checkbox } from 'primereact/checkbox';
import { BiCheck } from 'react-icons/bi';
import { debounce } from 'lodash';

import { Tooltip } from 'primereact/tooltip';
import './projection-add.css';

const ProjectionAddModel = ({ visible, projection, closeModel, setMonth, setYear }) => {

    const [isModalOpen, setIsModalOpen] = useState(true);
    const toast = useRef(null);
    const [type, setType] = useState('Add');
    const [userId, setUserID] = useState('');
    const [reconciled, setReconciled] = useState('N');
    const [reconciledDataAdd, setReconciledDataAdd] = useState('N');
    const [savedFields, setSavedFields] = useState({});


    const months = [
        { name: 'Jan', code: 'Jan' },
        { name: 'Feb', code: 'Feb' },
        { name: 'Mar', code: 'Mar' },
        { name: 'Apr', code: 'Apr' },
        { name: 'May', code: 'May' },
        { name: 'Jun', code: 'Jun' },
        { name: 'Jul', code: 'Jul' },
        { name: 'Aug', code: 'Aug' },
        { name: 'Sep', code: 'Sep' },
        { name: 'Oct', code: 'Oct' },
        { name: 'Nov', code: 'Nov' },
        { name: 'Dec', code: 'Dec' },
    ];

    // ------------------------------------------------------------
    const generateYearOptions = (startYear, endYear) => {
        const years = [];
        for (let year = startYear; year <= endYear; year++) {
            years.push({ name: year.toString(), code: year.toString() });
        }
        return years;
    };

    const years = generateYearOptions(2021, 2030);
    // ------------------------------------------------------------
    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);
    // -------------------------------------------------------------


    useEffect(() => {
        setIsModalOpen(true);
        formik.resetForm();
        setType('Add');
        if (projection.length != 0) {
            editCopyModal(projection, 'Edit');
        }
        if (setMonth) {
            getDataForMonth();
        }

    }, [visible]);

    const getDataForMonth = () => {
        var url = Api.API_BASE_URL + 'get-income-statement-setting';
        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        var _body = {
            month: setMonth,
            year: setYear
        }
        formik.setFieldValue('year', { name: setYear.toString(), code: setYear.toString() });
        formik.setFieldValue('month', { name: setMonth.toString(), code: setMonth.toString() });
        fetch(url, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(_body),
        })
            .then((response) => response.json())
            .then((Josn) => {
                if (Josn.error) {

                } else {
                    if (Josn.find == true) {
                        editCopyModal(Josn, 'Edit');
                    } else {
                        Josn.result.year = setYear;
                        Josn.result.month = setMonth;
                        setType('Add');
                        editCopyModal(Josn, 'Add');
                    }
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    const editCopyModal = (Json, colType) => {
        var rowData = Json.result;

        setUserID(rowData.id);
        setType(colType);
        // setIsModalOpen(true);

        formik.setFieldValue('re_complated', rowData.re_complated);
        formik.setFieldValue('AdminWagesFixedTick', rowData.AdminWagesFixedTick);

        formik.setFieldValue('totalOtherIncome', rowData.totalOtherIncome);
        formik.setFieldValue('totalIncome', rowData.totalIncome);

        // if (rowData.totalIncome == 0) {
        //     formik.setFieldValue('totalIncome', Json.total_income);
        // }


        formik.setFieldValue('gross_profit_box', rowData.gross_profit_box);

        formik.setFieldValue('poc', rowData.poc);
        formik.setFieldValue('cogsTotal', rowData.cogsTotal);
        
        // if (rowData.cogsTotal == 0) {
        //     formik.setFieldValue('cogsTotal', Json.cogs_total_income);
        // }

        formik.setFieldValue('uncategorized', rowData.uncategorized);
        formik.setFieldValue('MarketingSales', rowData.MarketingSales);
        formik.setFieldValue('AdminWages', rowData.AdminWages);
        formik.setFieldValue('vpConstructionOperations', rowData.vpConstructionOperations);
        formik.setFieldValue('Facilities', rowData.Facilities);
        formik.setFieldValue('GeneralAdmin', rowData.GeneralAdmin);
        formik.setFieldValue('AdminEmployementCosts', rowData.AdminEmployementCosts);
        formik.setFieldValue('Office', rowData.Office);
        formik.setFieldValue('TotalOtherCurrentAssets', rowData.TotalOtherCurrentAssets);
        formik.setFieldValue('NumberOfEmployees', rowData.NumberOfEmployees);
        formik.setFieldValue('NumberOfManagementStaff', rowData.NumberOfManagementStaff);
        formik.setFieldValue('NumberOfPms', rowData.NumberOfPms);
        formik.setFieldValue('TotalAccountsReceievable', rowData.TotalAccountsReceievable);
        formik.setFieldValue('MaterialsForFutureJobs', rowData.MaterialsForFutureJobs);
        formik.setFieldValue('DueFromToShareholder', rowData.DueFromToShareholder);
        formik.setFieldValue('WipCostsInExcessOfBillings', rowData.WipCostsInExcessOfBillings);
        formik.setFieldValue('TotalFixedAssets', rowData.TotalFixedAssets);
        formik.setFieldValue('TotalOtherAssets', rowData.TotalOtherAssets);
        formik.setFieldValue('TotalCurrentAssets', rowData.TotalCurrentAssets);
        formik.setFieldValue('TotalCurrentLiabilities', rowData.TotalCurrentLiabilities);
        formik.setFieldValue('TotalLongTermLiabilities', rowData.TotalLongTermLiabilities);
        formik.setFieldValue('TotalEquity', rowData.TotalEquity);
        formik.setFieldValue('CorpTaxPaid', rowData.CorpTaxPaid);
        formik.setFieldValue('ConstructionFinancing', rowData.ConstructionFinancing);
        formik.setFieldValue('ToBalanceCash', rowData.ToBalanceCash);
        formik.setFieldValue('cashend', Json.cashend);
        formik.setFieldValue('previousTotalAccountsReceievable', Json.previousTotalAccountsReceievable);
        formik.setFieldValue('previousTotalCurrentLiabilities', Json.previousTotalCurrentLiabilities);
        formik.setFieldValue('previousTotalLongTermLiabilities', Json.previousTotalLongTermLiabilities);

        formik.setFieldValue('custome_home_and_renovation', rowData.custome_home_and_renovation);
        formik.setFieldValue('commercial_and_multi_family', rowData.commercial_and_multi_family);

        formik.setFieldValue('total_income_forecast', Json.total_income_forecast);
        formik.setFieldValue('total_cogs_forecast', Json.total_cogs_forecast);        
    }

    const formik = useFormik({
        initialValues: {
            year: '',
            month: '', 
            re_complated: 'N',
            AdminWagesFixedTick: 'N',
            uncategorized: '',
            MarketingSales: '',
            totalIncome: '',
            poc: '',
            cogsTotal: '',
            AdminWages: '',
            vpConstructionOperations: '',
            Facilities: '',
            GeneralAdmin: '',
            AdminEmployementCosts: '',
            Office: '',
            TotalOtherCurrentAssets: '',
            NumberOfEmployees: '',
            NumberOfManagementStaff: '',
            NumberOfPms: '',
            TotalAccountsReceievable: '',
            MaterialsForFutureJobs: '',
            DueFromToShareholder: '',
            WipCostsInExcessOfBillings: '',
            TotalFixedAssets: '',
            TotalOtherAssets: '',
            TotalCurrentAssets: '',
            TotalCurrentLiabilities: '',
            TotalLongTermLiabilities: '',
            TotalEquity: '',
            CorpTaxPaid: '',
            ConstructionFinancing: '',
            ToBalanceCash: '',
            totalOtherIncome: '',
            gross_profit_box: '',
            previousTotalAccountsReceievable: 0,
            previousTotalCurrentLiabilities: 0,
            previousTotalLongTermLiabilities: 0,
            custome_home_and_renovation: '',
            commercial_and_multi_family: '',

            total_income_forecast: '',
            total_cogs_forecast: ''

        },

        validate: (data) => {
            let errors = {};

            if (!data.year) {
                errors.year = 'please select a year.';
            }
            if (!data.month) {
                errors.month = 'please select a month.';
            }
            return errors;
        },

        onSubmit: (data) => {
            closeModel();
        }
    });

    // const renderInputArea = (fieldName, title, showCheckbox = false) => (
    //     <div className="col-6 p-2">
    //         <label className='text-gray-600 text-sm'>{title}</label>
    //         {/* {showCheckbox && (
    //             <Checkbox
    //                 name="AdminWagesFixedTick"
    //                 value={formik.values.AdminWagesFixedTick}
    //                 checked={formik.values.AdminWagesFixedTick == 'Y' ? true : false}
    //                 onChange={(e) => {
    //                     formik.setFieldValue('AdminWagesFixedTick', e.target.checked ? 'Y' : 'N');
    //                 }}

    //             />

    //         )} */}
    //         <InputNumber
    //             inputId={formik.values[fieldName] < 0 ? 'number-negataive-price' : 'currency-positive'}
    //             id={fieldName}
    //             name={fieldName}
    //             mode="currency" currency="USD" locale="en-US"
    //             value={formik.values[fieldName]}
    //             className={classNames('pt-1',)} style={{ width: '100%' }}
    //             onChange={(e) => {
    //                 formik.setFieldValue(fieldName, e.value)
    //             }}
    //         />
    //     </div>


    // );



// Move debounced API call outside renderInputArea
const createDebouncedApiCall = (fieldName, formikValues, reconciledDataAdd, toast, onSaved) => {
  return debounce((value) => {
    const url = Api.API_BASE_URL + 'save-income-statement-setting';
    const token = localStorage.getItem('authToken');
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };

    const data = {
      ...formikValues,
      [fieldName]: value,
      fieldName: fieldName,
      fieldValue: value,
      reconciledDataAdd
    };

    fetch(url, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((json) => {
        if (json.error) {
          toast.current.show({ severity: 'error', summary: 'Error', detail: json.error });
        } else {
          onSaved(fieldName);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }, 1000);
};



const renderInputArea = (fieldName, title, tooltipText) => {
  const onSaved = (fn) => {
    setSavedFields(prev => ({ ...prev, [fn]: true }));
    setTimeout(() => setSavedFields(prev => { const n = { ...prev }; delete n[fn]; return n; }), 2000);
  };
  const debouncedApiCall = createDebouncedApiCall(fieldName, formik.values, reconciledDataAdd, toast, onSaved);
  const safeClass = `tooltip-field-${fieldName}`;
  return (
    <div className="proj-field">
      {tooltipText && <Tooltip target={`.${safeClass}`} position="top" />}
      <label>
        {title}
        {tooltipText && (
          <i
            className={`pi pi-info-circle ${safeClass}`}
            data-pr-tooltip={tooltipText}
            style={{ cursor: 'pointer' }}
          />
        )}
      </label>
      <div style={{ position: 'relative' }}>
        <InputNumber
          inputId={formik.values[fieldName] < 0 ? 'number-negataive-price' : 'currency-positive'}
          id={fieldName}
          name={fieldName}
          mode="currency"
          currency="USD"
          locale="en-US"
          value={formik.values[fieldName]}
          style={{ width: '100%' }}
          onChange={(e) => {
            formik.setFieldValue(fieldName, e.value);
            debouncedApiCall(e.value);
          }}
        />
        {savedFields[fieldName] && (
          <span style={{
            position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)',
            color: '#16a34a', fontSize: '14px', pointerEvents: 'none', zIndex: 1
          }}>
            <i className="pi pi-check" />
          </span>
        )}
      </div>
    </div>
  );
};

        
    const renderInputArea2 = (fieldName, title, tooltipText) => {
      const sanitizedFieldName = `tooltip-ro-${fieldName.toString().replace(/[^a-zA-Z0-9]/g, '-')}`;
      return (
        <div className="proj-field proj-field-readonly">
          {tooltipText && <Tooltip target={`.${sanitizedFieldName}`} position="top" />}
          <label>
            {title}
            {tooltipText && (
              <i
                className={`pi pi-info-circle ${sanitizedFieldName}`}
                data-pr-tooltip={tooltipText}
                style={{ cursor: 'pointer' }}
              />
            )}
          </label>
          <InputNumber
            disabled
            inputId={fieldName < 0 ? 'number-negataive-price' : 'currency-positive'}
            mode="currency"
            currency="USD"
            locale="en-US"
            value={fieldName}
            style={{ width: '100%' }}
          />
        </div>
      );
    }; 

    const renderInputAreaPer = (fieldName, title, tooltipText) => {
        const sanitizedFieldName = `tooltip-per-${fieldName.toString().replace(/[^a-zA-Z0-9]/g, '-')}`;
        return (
          <div className="proj-field proj-field-readonly">
            {tooltipText && <Tooltip target={`.${sanitizedFieldName}`} position="top" />}
            <label>
              {title}
              {tooltipText && (
                <i
                  className={`pi pi-info-circle ${sanitizedFieldName}`}
                  data-pr-tooltip={tooltipText}
                  style={{ cursor: 'pointer' }}
                />
              )}
            </label>
            <InputNumber
              disabled
              suffix="%"
              value={fieldName}
              style={{ width: '100%' }}
              mode="decimal"
              minFractionDigits={2}
              maxFractionDigits={2}
            />
          </div>
        );
      };

    const getCashEndData = () => {
        var subTotal = ((Number(formik.values.totalIncome) === 0 ? Number(formik.values.total_income_forecast) : Number(formik.values.totalIncome)) + Number(formik.values.poc) + Number(formik.values.totalOtherIncome) + Number(formik.values.cashend)) - (Number(formik.values.cogsTotal) + Number(formik.values.uncategorized) + Number(formik.values.MarketingSales) + Number(formik.values.AdminWages) + Number(formik.values.vpConstructionOperations) + Number(formik.values.Facilities) + Number(formik.values.Office) + Number(formik.values.GeneralAdmin) + Number(formik.values.AdminEmployementCosts));

        var bv30To37 = (Number(formik.values.TotalOtherCurrentAssets) + Number(formik.values.MaterialsForFutureJobs) + Number(formik.values.DueFromToShareholder) + Number(formik.values.WipCostsInExcessOfBillings) + Number(formik.values.TotalFixedAssets) + Number(formik.values.TotalOtherAssets) + Number(formik.values.TotalCurrentAssets));

        var bv42to46 = (Number(formik.values.CorpTaxPaid) + Number(formik.values.ConstructionFinancing) + Number(formik.values.ToBalanceCash));
        var bj32to34 = (Number(formik.values.MaterialsForFutureJobs) + Number(formik.values.DueFromToShareholder) + Number(formik.values.WipCostsInExcessOfBillings));


        // formik.setFieldValue('previousTotalAccountsReceievable', rowData.previousTotalAccountsReceievable);
        // formik.setFieldValue('previousTotalCurrentLiabilities', rowData.previousTotalCurrentLiabilities);
        // formik.setFieldValue('previousTotalLongTermLiabilities', rowData.previousTotalLongTermLiabilities);
        var previousTotalAccountsReceievable = (Number(formik.values.previousTotalAccountsReceievable) - Number(formik.values.TotalAccountsReceievable));
        var previousTotalCurrentLiabilities = (Number(formik.values.TotalCurrentLiabilities) - Number(formik.values.previousTotalCurrentLiabilities));


        var previousTotalLongTermLiabilities = (Number(formik.values.previousTotalLongTermLiabilities) - Number(formik.values.TotalLongTermLiabilities));

        var cashEnd = subTotal + bv30To37 + bv42to46 - bj32to34 + previousTotalAccountsReceievable + previousTotalCurrentLiabilities - previousTotalLongTermLiabilities;
        return cashEnd;
    }

    const getTotalExpenses = () => {
        return (
            Number(formik.values.uncategorized) +
            Number(formik.values.MarketingSales) +
            Number(formik.values.AdminWages) +
            Number(formik.values.vpConstructionOperations) +
            Number(formik.values.Facilities) +
            Number(formik.values.Office) +
            Number(formik.values.GeneralAdmin) +
            Number(formik.values.AdminEmployementCosts)
        );
    };

    const reconciledChange = (e) => {
        const isChecked = e.target.checked;
        formik.setFieldValue('re_complated', isChecked ? 'Y' : 'N');
        setReconciled(isChecked ? 'Y' : 'N');
        setReconciledDataAdd('Y');
        const url = Api.API_BASE_URL + 'save-income-statement-setting';
        const token = localStorage.getItem('authToken');
        const headers = { 'Content-Type': 'application/json', 'Authorization': token ? `Bearer ${token}` : '' };
        const data = { ...formik.values, re_complated: isChecked ? 'Y' : 'N', fieldName: 're_complated', fieldValue: isChecked ? 'Y' : 'N', reconciledDataAdd: 'Y' };
        fetch(url, { method: 'POST', headers, body: JSON.stringify(data) })
            .then(r => r.json())
            .then(json => {
                if (json.error) { toast.current.show({ severity: 'error', summary: 'Error', detail: json.error }); return; }
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Reconciled status saved' });
            })
            .catch(err => console.error('Error:', err));
    };

    const totalIncome = Number(formik.values.totalIncome) === 0 ? Number(formik.values.total_income_forecast) : Number(formik.values.totalIncome);
    const totalCogs   = Number(formik.values.cogsTotal)   === 0 ? Number(formik.values.total_cogs_forecast)   : Number(formik.values.cogsTotal);
    const grossProfit = totalIncome + Number(formik.values.poc) + Number(formik.values.totalOtherIncome) - totalCogs;
    const grossProfitPct = (grossProfit / (totalIncome + Number(formik.values.poc) + Number(formik.values.totalOtherIncome))) * 100;
    const totalExp    = getTotalExpenses();
    const totalExpPct = (totalExp / (totalIncome + Number(formik.values.poc) + Number(formik.values.totalOtherIncome))) * 100;
    const netProfit   = totalIncome + Number(formik.values.poc) + Number(formik.values.totalOtherIncome) - totalCogs - Number(formik.values.uncategorized) - Number(formik.values.MarketingSales) - Number(formik.values.AdminWages) - Number(formik.values.AdminEmployementCosts) - Number(formik.values.vpConstructionOperations) - Number(formik.values.Facilities) - Number(formik.values.Office) - Number(formik.values.GeneralAdmin);
    const netProfitPct = (netProfit / (totalIncome + Number(formik.values.poc) + Number(formik.values.totalOtherIncome))) * 100;

    return (
        <>
            <Toast ref={toast} />
            <Dialog
                    header={`Income Statement — ${formik.values.month.name || ''} ${formik.values.year.name || ''}`}
                    headerClassName="centered-header"
                    visible={isModalOpen}
                    maximizable
                    style={{ width: '38vw' }}
                    dismissableMask
                    onHide={() => { setIsModalOpen(false); closeModel(); }}
                >
                    <form onSubmit={formik.handleSubmit}>

                        {/* ── Meta bar ── */}
                        <div className="proj-meta-bar">
                            <div className="proj-meta-item">
                                <i className="pi pi-calendar" style={{ fontSize: '14px', color: '#2563eb' }} />
                                <span>Year</span>
                                <span className="proj-meta-badge">{formik.values.year.name || '—'}</span>
                            </div>
                            <div className="proj-meta-divider" />
                            <div className="proj-meta-item">
                                <i className="pi pi-clock" style={{ fontSize: '14px', color: '#2563eb' }} />
                                <span>Month</span>
                                <span className="proj-meta-badge">{formik.values.month.name || '—'}</span>
                            </div>
                            <div className="proj-reconciled-row">
                                <Checkbox
                                    inputId="reconciled-chk"
                                    name="reconciled"
                                    value={formik.values.re_complated}
                                    checked={formik.values.re_complated === 'Y'}
                                    onChange={reconciledChange}
                                />
                                <label htmlFor="reconciled-chk" style={{ cursor: 'pointer', fontWeight: 600, color: formik.values.re_complated === 'Y' ? '#15803d' : '#64748b' }}>
                                    {formik.values.re_complated === 'Y' ? '✔ Reconciled' : 'Mark as Reconciled'}
                                </label>
                            </div>
                        </div>

                        {/* ── INCOME STATEMENT ── */}
                        <div className="proj-section">
                            <div className="proj-section-header blue"><i className="pi pi-arrow-up" />Income Statement</div>
                            <div className="proj-section-body">
                                {renderInputArea2(Number(formik.values.total_income_forecast), 'Total Income (Forecast)', 'This is pulled from Revenue Projection (Fee Per Month + Direct Cost)')}
                                {renderInputArea('totalIncome', 'Total Income (Actual)', "Updates this month only. This value does not affect future projections.")}
                                {renderInputArea('totalOtherIncome', 'Total Other Income', "Updates this month only. This value does not affect future projections.")}
                                {renderInputArea('poc', 'POC', 'POC is entered manually and duplicated in all future months if that month is not reconciled')}
                            </div>
                        </div>

                        {/* ── COST OF GOODS SOLD ── */}
                        <div className="proj-section">
                            <div className="proj-section-header orange"><i className="pi pi-shopping-cart" />Cost of Goods Sold</div>
                            <div className="proj-section-body">
                                {renderInputArea2(Number(formik.values.total_cogs_forecast), 'Total COGS (Forecast)', 'COGS is pulled from Revenue Projection (Total Direct Cost)')}
                                {renderInputArea('cogsTotal', 'Total COGS (Actual)', "Updates this month only. This value does not affect future projections.")}
                            </div>
                        </div>

                        {/* ── GROSS PROFIT ── */}
                        <div className="proj-section">
                            <div className="proj-section-header green"><i className="pi pi-chart-bar" />Gross Profit</div>
                            <div className="proj-section-body">
                                {renderInputArea2(grossProfit, 'Gross Profit', 'Gross Profit = Total Income + POC + Total Other Income - COGS Total')}
                                {renderInputAreaPer(grossProfitPct, 'Gross Profit %', 'Gross Profit % = (Gross Profit / Total Income) × 100')}
                            </div>
                        </div>

                        {/* ── EXPENSES ── */}
                        <div className="proj-section">
                            <div className="proj-section-header red"><i className="pi pi-minus-circle" />Expenses</div>
                            <div className="proj-section-body">
                                {renderInputArea('uncategorized', 'Uncategorized', "Updates the current month. If 'Reconciled' is OFF, this new value will also copy forward to future months. If 'Reconciled' is ON, it saves for this month only.")}
                                {renderInputArea('MarketingSales', 'Marketing & Sales', "Updates the current month. If 'Reconciled' is OFF, this new value will also copy forward to future months. If 'Reconciled' is ON, it saves for this month only.")}
                                <div className="proj-checkbox-field">
                                    <Checkbox
                                        inputId="admin-wages-fixed"
                                        name="AdminWagesFixedTick"
                                        value={formik.values.AdminWagesFixedTick}
                                        checked={formik.values.AdminWagesFixedTick === 'Y'}
                                        onChange={(e) => formik.setFieldValue('AdminWagesFixedTick', e.target.checked ? 'Y' : 'N')}
                                    />
                                    <label htmlFor="admin-wages-fixed" style={{ cursor: 'pointer' }}>Fix Admin Wages (will not change on refresh)</label>
                                    <Tooltip target=".tooltip-field-AdminWagesFixedTick" position="top" />
                                    <i
                                        className="pi pi-info-circle tooltip-field-AdminWagesFixedTick"
                                        data-pr-tooltip="Locks the wages for this specific month so they cannot be overwritten by changes made in previous months."
                                        style={{ cursor: 'pointer', marginLeft: '6px', color: '#64748b' }}
                                    />
                                </div>
                                {renderInputArea('vpConstructionOperations', 'VP Construction Operations', "Updates the current month. If 'Reconciled' is OFF, this new value will also copy forward to future months. If 'Reconciled' is ON, it saves for this month only.")}
                                {renderInputArea('AdminEmployementCosts', 'Admin Employment Costs', "Updates this month and automatically copies to all future unreconciled months as a new baseline.")}
                                {renderInputArea('AdminWages', 'Owners Comp & Benefits', "Updates the current month. If 'Reconciled' is OFF, this new value will also copy forward to future months. If 'Reconciled' is ON, it saves for this month only.")}
                                {renderInputArea('Facilities', 'Facilities', "Updates the current month. If 'Reconciled' is OFF, this new value will also copy forward to future months. If 'Reconciled' is ON, it saves for this month only.")}
                                {renderInputArea('Office', 'Office', "Updates the current month. If 'Reconciled' is OFF, this new value will also copy forward to future months. If 'Reconciled' is ON, it saves for this month only.")}
                                {renderInputArea('GeneralAdmin', 'General & Admin', "Updates the current month. If 'Reconciled' is OFF, this new value will also copy forward to future months. If 'Reconciled' is ON, it saves for this month only.")}
                                {renderInputArea2(totalExp, 'Total Expenses', 'Sum of all expense lines')}
                                {renderInputAreaPer(totalExpPct, 'Total Expenses %', 'Total Expenses % = (Total Expenses / Total Income) × 100')}
                            </div>
                        </div>

                        {/* ── NET PROFIT ── */}
                        <div className="proj-section">
                            <div className="proj-section-header green"><i className="pi pi-dollar" />Net Profit</div>
                            <div className="proj-section-body">
                                {renderInputArea2(netProfit, 'Net Profit', 'Net Profit = Total Income + POC + Other Income - COGS - All Expenses')}
                                {renderInputAreaPer(netProfitPct, 'Net Profit %', 'Net Profit % = (Net Profit / Total Income) × 100')}
                            </div>
                        </div>

                        {/* ── PROJECTIONS & ASSUMPTIONS ── */}
                        <div className="proj-section">
                            <div className="proj-section-header purple"><i className="pi pi-chart-line" />Projections &amp; Assumptions</div>
                            <div className="proj-section-body">
                                {renderInputArea('custome_home_and_renovation', 'Custom Home & Renovation', 'This is entered manually')}
                                {renderInputArea('commercial_and_multi_family', 'Commercial & Multi-Family', 'This is entered manually')}
                            </div>
                        </div>

                        {/* ── BALANCE SHEET ── */}
                        <div className="proj-section">
                            <div className="proj-section-header teal"><i className="pi pi-building" />Balance Sheet</div>
                            <div className="proj-section-body">
                                {renderInputArea('TotalAccountsReceievable', 'Total Accounts Receivable', "Updates this month and automatically copies to all future unreconciled months as a new baseline.")}
                                {renderInputArea('TotalOtherCurrentAssets', 'Total Other Current Assets', "Updates this month only. This value does not affect future projections.")}
                                {renderInputArea('MaterialsForFutureJobs', 'Materials for Future Jobs', 'Account S.54P — for ratios only, not in cashflow')}
                                {renderInputArea('DueFromToShareholder', 'Due From/To Shareholder', 'Account 1348 — for ratios only, not in cashflow')}
                                {renderInputArea('WipCostsInExcessOfBillings', 'WIP Costs in Excess of Billings', 'Account S150 — for ratios only, not in cashflow')}
                                {renderInputArea('TotalFixedAssets', 'Total Fixed Assets', "Updates this month only. This value does not affect future projections.")}
                                {renderInputArea('TotalCurrentLiabilities', 'Total Current Liabilities', "Updates this month and automatically copies to all future unreconciled months as a new baseline.")}
                                {renderInputArea('TotalLongTermLiabilities', 'Total Long Term Liabilities', "Updates this month and automatically copies to all future unreconciled months as a new baseline.")}
                                {renderInputArea('TotalEquity', 'Total Equity', "Updates this month and automatically copies to all future unreconciled months as a new baseline.")}
                                {renderInputArea('CorpTaxPaid', 'Corp Tax Paid', 'Manually entered')}
                                {renderInputArea('ToBalanceCash', 'To Balance Cash', "Updates this month only. This value does not affect future projections.")}
                                {renderInputArea2(getCashEndData(), 'Cash End', 'Cash End formula: Subtotal + assets changes + liability changes')}
                            </div>
                            {/* Staff numbers — full width row of 3 */}
                            <div className="proj-section-body proj-staff-group" style={{ gridTemplateColumns: '1fr 1fr 1fr', borderTop: '1px solid #e2e8f0' }}>
                                <div className="proj-field">
                                    <label>No. of Employees</label>
                                    <InputText id="NumberOfEmployees" name="NumberOfEmployees" value={formik.values.NumberOfEmployees} style={{ width: '100%' }} onChange={(e) => formik.setFieldValue('NumberOfEmployees', e.target.value)} />
                                </div>
                                <div className="proj-field">
                                    <label>No. of Mgmt Staff</label>
                                    <InputText id="NumberOfManagementStaff" name="NumberOfManagementStaff" value={formik.values.NumberOfManagementStaff} style={{ width: '100%' }} onChange={(e) => formik.setFieldValue('NumberOfManagementStaff', e.target.value)} />
                                </div>
                                <div className="proj-field">
                                    <label>No. of PM's</label>
                                    <InputText id="NumberOfPms" name="NumberOfPms" value={formik.values.NumberOfPms} style={{ width: '100%' }} onChange={(e) => formik.setFieldValue('NumberOfPms', e.target.value)} />
                                </div>
                            </div>
                        </div>

                        {/* ── Footer ── */}
                        <div className="proj-footer">
                            <button type="button" className="proj-close-btn" onClick={() => closeModel()}>
                                <i className="pi pi-times" />
                                Close
                            </button>
                        </div>

                    </form>
                </Dialog>
        </>
    )
}

export default ProjectionAddModel

